export const LABS_ALLOWED_ADDRESSES = [
  'inj1kj28eq2lx5kyup7dpjpxa285dmd0h4gmsrpxsg',
  'inj1arzqy3unl9llc9cpht80ln938jtrz7l3frl0wd',
  'inj1995xnrrtnmtdgjmx0g937vf28dwefhkhy6gy5e',
  'inj17gkuet8f6pssxd8nycm3qr9d9y699rupv6397z',
  'inj16n8psgw8g272hruar99dx8048ayjcqwd7fdpkc',
  'inj122c6jktvt3w264rhfzmvw8kwasng9s4hq5h329',
  'inj1zne967u94a86amyfp3x3m8ncg34u35k6asjk9n',
  'inj19e4rtzhzjj246eth23xsw8a754r7hmkfsau872',
  'inj158lgtwt4n9u053j3p6r4ew2mzzky2uvy5vzyfg',
  'inj1zv05422w9usf7psau2s85sgwu35csd457f2p7z',
  'inj1t0g8rqyzmag8g5e5gvllntlec2wkqueu4dhzlt',
  'inj1jr094svc02v8ft5x3ecrcnrryp2g5vt23ngulu',
  'inj1p46fy9vw2a42vs7zpa9upfxmpu29547y35g2pl',
  'inj1prszv4ywj6df62ghddmquyy2ec58nn0x86nce2',
  'inj13njxly446jm3gd8y84qnk3sm6wu0pjjc47mwl6',
  'inj1cym4l645rrag295h8n3r6elrelt8p6j5yn2mn7',
  'inj1p4xw02g5fn3702f9f5hhy0mnenmfnf80rktall',
  'inj133xeq92ak7p87hntvamgq3047kj8jfqhry92a8',
  'inj1ltw3qv95lmn4pcj7hk8sakaetqk5ta9knqklq6',
  'inj18xg8yh445ernwxdquklwpngffqv3agfyt5uqqs',
  'inj1td98nuzcmql06hzwh4dgfy62qrqmjulzyc29ae'
] as const
